<!--
 Terms Facet Component
 Shows available shop terms for given search input
 devs@droxit.de
 Copyright (c) 2022 droxIT GmbH
-->

<template>
  <b-container class="facet" fluid="md" v-if="showFacet">
    <b-row class="rocketsearch-facet-row" align-v="center">
      <b-col cols=3 class="rocketsearch-facet-label">
        <span> {{ facet.label }} </span>
      </b-col>
      <b-col cols=9 class="rocketsearch-facet-content">
        <div class="rocketsearch-tags-list">
          <span v-for="entry in facet.options" :key="entry.value">
            <span v-if="isActive(entry.value)" v-on:click="removeFilter(facet.name, entry.value)" class="rocketsearch-tags-list-item active">
              <span class="rocketsearch-tags-text"> {{ entry.value }} </span>
            </span>
            <span v-else v-on:click="selectFilter(facet.name, entry.value)" class="rocketsearch-tags-list-item">
              <span class="rocketsearch-tags-text"> {{ entry.value }} </span>
             </span>
         </span>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: 'TermsFacetMobile',
    props: {
      facet: Object,
      filter: Array
    },
    data: function(){
      return {
         selected: this.filter || []
      }
    },
    computed: {
      showFacet: function(){
        return this.facet.options.length > 0;
      }
    },
    methods: {
      selectFilter(filter_name, value){
        var selected = this.selected;
        selected.push(value);

        this.$root.$emit('RocketFilterSelectedEvent', { name: filter_name, options: selected });
      },
      removeFilter(filter_name, value){
        let opt_index = this.selected.indexOf(value);

        if(opt_index < 0){
          return;
        }

        var selected = this.selected;
        selected.splice(opt_index, 1);
        this.$root.$emit('RocketFilterSelectedEvent', { name: filter_name, options: selected });
      },
      isActive(value){
        if(this.selected.includes(value)){
          return true;
        }

        return false;
      }
    }
  }
</script>
